import axios from 'axios';
import { getApiUrl } from '../utils/constants';
import { handleDecodeJSON } from '../utils/encodeDecodeJson';

export const fetchSafeBrowserInfo = async (projectShortName) => {
    const url = `${getApiUrl()}/api/safe-browser/info/${projectShortName}`;
    const result = await axios.get(url);
    const response = result.data;
    const decodedData = await handleDecodeJSON({ decodeJSON: response?.data });
    return { ...response, data: decodedData };
};
